import { useEffect } from 'react';
import { subscribeConsentLevelChange } from '@stepstone/user-consent-events';
import { modalActions } from '../wrappers/Modal/modalSlice.js';
import { useAppDispatch } from './redux/index.js';
const consentLevelChangeCallback = (dispatch) => () => {
    dispatch(modalActions.setGDPRModalActive(false));
};
export const useGDPRModalActive = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        let unsubscribe;
        if (typeof window !== 'undefined') {
            const observer = new MutationObserver(() => {
                const target = document.querySelector('#GDPRConsentManagerContainer > *');
                if (target) {
                    dispatch(modalActions.setGDPRModalActive(true));
                    unsubscribe = subscribeConsentLevelChange(consentLevelChangeCallback(dispatch));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }
        return () => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
//# sourceMappingURL=useGDPRModalActive.js.map